export async function resizeVendorLogo(source: string): Promise<string> {
  const image = await new Promise<HTMLImageElement>((resolve, reject) => {
    const element = new Image();
    element.onload = () => resolve(element);
    element.onerror = () => reject(new Error('无法读取厂商 Logo'));
    element.src = source;
  });
  const canvas = document.createElement('canvas');
  canvas.width = 160; canvas.height = 160;
  const context = canvas.getContext('2d');
  if (!context) throw new Error('当前浏览器无法处理图片');
  context.drawImage(image, 0, 0, 160, 160);
  return canvas.toDataURL('image/png');
}
